import { useEffect, useState, useRef } from 'react';
import { graphql, readInlineData } from 'react-relay';
import get from 'lodash.get';
import { trackEvent } from 'dibs-tracking';
import { getOriginalQueryHashParamValue } from '../utils/hashFragmentHelpers';

export const UNRESOLVED_SEARCH_CORRECTION = null;
export const RESOLVED_SEARCH_CORRECTION = '';

export function useSearchCorrections({ itemSearch, includeTracking }) {
    const data = readInlineData(
        graphql`
            fragment useSearchCorrections_itemSearch on ItemSearchQueryConnection @inline {
                searchCorrections {
                    forceSearchUri
                    originalSearchTerm
                    semanticSearchTerm
                    classificationLevel
                    classificationSearchTerm
                }
            }
        `,
        itemSearch
    );

    const [searchCorrectionTerm, updateSearchCorrectionTerm] = useState(
        get(data, 'searchCorrections.semanticSearchTerm') ||
            get(data, 'searchCorrections.classificationSearchTerm') ||
            UNRESOLVED_SEARCH_CORRECTION
    );

    const classificationTrackingRef = useRef({
        includeClassificationTracking: includeTracking,
        classificationLevel: get(data, 'searchCorrections.classificationLevel'),
        classificationSearchTerm: get(data, 'searchCorrections.classificationSearchTerm'),
    });

    useEffect(() => {
        updateSearchCorrectionTerm(currentSearchTerm => {
            const oqParam = decodeURIComponent(
                getOriginalQueryHashParamValue(window.location.hash) || ''
            );

            if (oqParam && oqParam !== currentSearchTerm) {
                return oqParam;
            } else {
                return currentSearchTerm || RESOLVED_SEARCH_CORRECTION;
            }
        });
    }, []);

    useEffect(() => {
        const {
            classificationLevel,
            classificationSearchTerm,
            includeClassificationTracking,
        } = get(classificationTrackingRef, 'current', {});
        if (classificationLevel && classificationSearchTerm && includeClassificationTracking) {
            trackEvent({
                category: 'product list',
                action: 'classified search',
                label: `${classificationSearchTerm} | ${classificationLevel}`,
            });
        }
    }, []);

    return [searchCorrectionTerm];
}

/**
 * For class components, since they can't use hooks :`(
 */
export function SearchCorrectionsProvider({ itemSearch, children }) {
    const [searchCorrectionTerm] = useSearchCorrections({ itemSearch, includeTracking: true });

    return children({ searchCorrectionTerm });
}
